import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

const getAppServices = (): IEditorAppServices => AppServiceProvider.getInstance().getAppServices() as
    IEditorAppServices;

const getSelectionService = () => getAppServices().viewableServiceLayer?.selectionService;

export const clearNoteSelection = (): void => {
    const model = getSelectionService().currentSlide?.noteData;
    if (model?.selected) {
        model.noteInstance?.triggerBlur({ needUpd8: true });
        model.selected = false;
    }
};
